import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import type { ComponentsStore, ViewerComponent } from 'feature-components'
import type { ICurrentRouteInfo } from 'feature-router'
import { ComponentsStoreSymbol } from 'feature-components'
import { CurrentRouteInfoSymbol, ILayoutDoneService, LayoutDoneServiceSymbol } from '@wix/thunderbolt-symbols'
import createCompBehaviorHandlers from './createCompBehaviorHandlers'
import { getPageBackgroundId } from '@wix/thunderbolt-commons'

const noop = () => {}
const BackgroundGroup = 'SITE_BACKGROUND'

const viewerManagerActionsAndBehaviorsApiFactory = (
	componentsStore: ComponentsStore,
	currentRouteInfo: ICurrentRouteInfo,
	layoutDoneService: ILayoutDoneService
): IViewerManagerImplementor<'actionsAndBehaviors'> => {
	const getPrimaryPageId = () => currentRouteInfo.getCurrentRouteInfo()?.pageId || ''
	const compBehaviorHandlersForCompType = createCompBehaviorHandlers(layoutDoneService)

	return {
		actionsAndBehaviors: {
			resetBehaviorsRegistration: noop,
			executeAction: noop,
			enableAction: noop,
			disableAction: noop,
			handleBehavior: (behavior, { callback }) => {
				const targetCompId =
					behavior.targetId === BackgroundGroup ? getPageBackgroundId(getPrimaryPageId()) : behavior.targetId

				const component = componentsStore.get<ViewerComponent>(targetCompId)

				if (component) {
					const handler = compBehaviorHandlersForCompType[component.componentType]?.[behavior.name] ?? noop
					handler(component, behavior, callback)
				}
			},
		},
	}
}
export const ViewerManagerActionsAndBehaviorsApi = withDependencies(
	[ComponentsStoreSymbol, CurrentRouteInfoSymbol, LayoutDoneServiceSymbol],
	viewerManagerActionsAndBehaviorsApiFactory
)
